import styled from '@emotion/styled';

interface QcsStackProps {
  gap?: string;
  direction?: 'column' | 'row';
}

export const QcsStack = styled.div<QcsStackProps>(({ gap = '0.75rem', direction = 'column' }) => ({
  display: 'flex',
  flexDirection: direction,
  gap,
}));